import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import {useDeleteFeaturedProductsListMutation} from 'api';
import {useSnackbar} from 'notistack';

function FeaturedProductsListDeleteIconButton({featuredProductsListId}) {
  const [deleteFeaturedProductsList, deleteFeaturedProductsListResult] =
    useDeleteFeaturedProductsListMutation();
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const {enqueueSnackbar} = useSnackbar();

  const handleDelete = async () => {
    try {
      await deleteFeaturedProductsList(featuredProductsListId).unwrap();
      enqueueSnackbar('FeaturedProductsList deleted', {variant: 'success'});
      setIsModalOpen(false);
    } catch (error) {
      const message = error.status === 400 ? error.data?.details?.[0]?.message : undefined;
      enqueueSnackbar(message || `Error deleting FeaturedProductsList`, {variant: 'error'});
    }
  };

  return (
    <>
      <Dialog open={isModalOpen} maxWidth="xs">
        <DialogTitle>Delete List</DialogTitle>
        <DialogContent dividers>Are you sure you want to delete this List?</DialogContent>
        <DialogActions>
          <Button
            disabled={deleteFeaturedProductsListResult.isLoading}
            autoFocus
            onClick={() => setIsModalOpen(false)}
          >
            Cancel
          </Button>
          <Button
            disabled={deleteFeaturedProductsListResult.isLoading}
            color="error"
            endIcon={
              deleteFeaturedProductsListResult.isLoading ? <CircularProgress size={16} /> : null
            }
            onClick={handleDelete}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <IconButton
        onClick={() => setIsModalOpen(true)}
        disabled={deleteFeaturedProductsListResult.isLoading}
        aria-label="delete"
        color="error"
      >
        <DeleteIcon />
      </IconButton>
    </>
  );
}

export default FeaturedProductsListDeleteIconButton;
